import { styled } from "@pigment-css/react";
import { MicrophoneIcon } from "@acto/web-common/components";
import { useTranslations } from "@acto/web-common/locales";
import { GlassButton } from "@acto/taskpane/field-sales-2/components/primitives/GlassButton";
import { PrimaryActionButton } from "./ui/PrimaryActionButton";
import { VoiceBar } from "./ui/VoiceBar";

const Footer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: theme.fieldSalesTwo.spacing[12],
  padding: `${theme.fieldSalesTwo.spacing[16]} ${theme.fieldSalesTwo.spacing[16]} ${theme.fieldSalesTwo.spacing[32]}`,
}));

const StartButton = styled(GlassButton)({ width: "100%" });

interface FlowFooterProps {
  writing: boolean;
  recording: boolean;
  elapsedSeconds: number;
  confirmDisabled: boolean;
  onConfirm: () => void;
  onEnterWriting: () => void;
  onStartRecording: () => void;
  onStop: () => void;
}

export function FlowFooter({
  writing,
  recording,
  elapsedSeconds,
  confirmDisabled,
  onConfirm,
  onEnterWriting,
  onStartRecording,
  onStop,
}: FlowFooterProps) {
  const t = useTranslations("fieldSalesTwo.recaps");

  if (!writing) {
    return (
      <Footer>
        <GlassButton
          type="button"
          onClick={() => {
            onEnterWriting();
            onStartRecording();
          }}
        >
          <MicrophoneIcon />
          {t("compose.startRecording")}
        </GlassButton>
      </Footer>
    );
  }

  return (
    <Footer>
      {recording ? (
        <VoiceBar elapsedSeconds={elapsedSeconds} onStop={onStop} />
      ) : (
        <StartButton type="button" onClick={onStartRecording}>
          <MicrophoneIcon />
          {t("compose.startRecording")}
        </StartButton>
      )}
      <PrimaryActionButton type="button" onClick={onConfirm} disabled={confirmDisabled}>
        {t("creation.confirm")}
      </PrimaryActionButton>
    </Footer>
  );
}
